import { request } from 'yunkecom/dist/utils';
import qs from 'qs';

// 获取用户信息
export const getUserInfo = () => request.postJson('/pc/home/userInfo').then((res) => res.data);

// 获取用户菜单
export const getMenu = (headers) => request.get('/pc/authority/permissions', {}, headers);

export const getModulus = () => {
  const url = '/usercenter/login/getSecureKey';
  const data = {};
  return request.postJson(url, data).then((res) => res.data);
};

export const loginStatistics = () => request.postJson('/pc/home/logLogin ');

// 用户登录
export const listUserByPhone = (data) => request.postJson('/usercenter/login/listUserByPhone', data).then((res) => res);

// 用户登录
export const login = (data) => request.postJson('/usercenter/login/pcLogin', data).then((res) => res);

// 离职员工列表左侧tree
export const getDeptTree = (data) => request
  .postJson('/usercenter/dept/tree', {
    showUser: true,
    ...data,
  });

/**
 *
 * @param {*} keyword 关键词
 * @param {*} type
 * @param {*} queryQywxStatus 是否绑定企业微信
 * @param {*} limit 条数 默认50
 * @param {*} phoneOnly 是否离职
 * @returns
 */
export const searchQuitUserDept = (keyword, type = 3, queryQywxStatus, limit = 20, phoneOnly = false) => request.postJson('/usercenter/dept/search', {
  keyword, type, limit, phoneOnly, showUserStatus: 2, queryQywxStatus,
}).then((res) => res.data);

/**
 * 手机页面调用pc 接口需要登录
 */

export const getLoginSign = (header) => request.get('/yunkeCellPhone/login/getLoginSign', {}, header);

/**
 * 缓存清理
 * @param {*} data
 * @returns
 */
export const checkCache = (data) => request.postForm('/pc/home/checkCache', qs.stringify(data));

/**
 * open版本通知
 */
export const listSystemNotice = (data) => request.postForm('/pc/notice/listSystemNotice', qs.stringify(data));

/**
 * 版本通知--已读-批量
 */
export const batchHaveRead = (data) => request.postJson('/pc/notice/batchHaveRead', data);
